module.exports = __webpack_public_path__ + "img/Group 74.75aa0ecc.png";